import React, { useState, useRef } from "react";
import { Button } from 'antd';
import { Modal, Input, Typography } from "antd";
import "./PopUpVerificationCode.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const { Text } = Typography;

const PopUpVerificationCode = ({ email, onClose, onVerified, visible = true }) => {
  const [values, setValues] = useState(Array(6).fill(""));
  const [error, setError] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const [successMessageVisible, setSuccessMessageVisible] = useState(false);
  const inputsRef = useRef([]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);

    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !values[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleResendCode = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/registration/resendCode?email=${email}`, {
        method: "POST",
      });
  
      if (response.ok) {
        setResendMessage("Nowy kod został wysłany na e-mail.");
        setTimeout(() => setResendMessage(""), 3000);
      } else {
        const data = await response.json();
        setResendMessage(data.message || "Nie udało się wysłać kodu.");
      }
    } catch (err) {
      setResendMessage("Wystąpił błąd przy ponownym wysyłaniu.");
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("Text").trim();
    if (!/^\d{6}$/.test(pasteData)) return;
  
    const newValues = pasteData.split("");
    setValues(newValues);
  
    // Przesuń focus na ostatnie pole
    const lastIndex = newValues.length - 1;
    inputsRef.current[lastIndex]?.focus();
  };

  const handleVerify = async () => {
    const code = values.join("");

    if (code.length < 6) {
      setError("Wpisz pełny kod (6 cyfr).");
      return;
    }

    const confirmData = {
      email, 
      code
    };


    try {
      const response = await fetch(`${API_BASE_URL}/api/registration/confirm`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(confirmData),
      });

      if (response.ok) {
        setSuccessMessageVisible(true);
        setTimeout(() => {
          setSuccessMessageVisible(false);
          onVerified();
        }, 2500);
      } else {
        const data = await response.json();
        setError(data.message || "Błąd weryfikacji");
      }
    } catch (err) {
      setError("Wystąpił błąd połączenia z serwerem.");
    }
  };

  return (
    <Modal
      title="Weryfikacja e-maila"
      open={visible}
      onCancel={onClose}
      onOk={handleVerify}
      okText="Potwierdź"
      cancelText="Anuluj"
      okButtonProps={{ className: "custom-ok-btn" }}
      cancelButtonProps={{ className: "custom-cancel-btn" }}
      footer={successMessageVisible ? null : undefined} 
      maskClosable={false}
      keyboard={false}
    >
      {successMessageVisible ? (
        <div className="success-message">
          <Typography.Title level={4}>Weryfikacja zakończona sukcesem!</Typography.Title>
          <p>Możesz się teraz zalogować.</p>
        </div>
      ) : (
        <>
          <p>
            Wpisz kod, który otrzymałeś na e-mail: <strong>{email}</strong>
          </p>

          <div className="code-input-group">
            {values.map((val, i) => (
              <Input
                key={i}
                ref={(el) => (inputsRef.current[i] = el)}
                maxLength={1}
                value={val}
                onChange={(e) => handleChange(e.target.value, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
                onPaste={i === 0 ? handlePaste : undefined}
                className="code-input"
                style={{
                  width: "48px",
                  height: "54px",
                  fontSize: "24px",
                  textAlign: "center",
                  borderRadius: "8px",
                }}
              />
            ))}
          </div>

          {error && (
            <div style={{ marginTop: "8px" }}>
              <Text type="danger">{error}</Text>
            </div>
          )}

          <div style={{ marginTop: "12px", textAlign: "center" }}>
            <Button type="link" onClick={handleResendCode}>
              Wyślij kod ponownie
            </Button>
            {resendMessage && (
              <div style={{ marginTop: "4px" }}>
                <Text type="secondary">{resendMessage}</Text>
              </div>
            )}
          </div>
        </>
      )}
    </Modal>
  );
};

export default PopUpVerificationCode;
